<template>
  <div class="paper-list">
    <div class="container-head">
      <div class="container-head-title">
        <i
          :class="labal.labalIcon"
          class="iconfont"
          style="color: #f3a954;font-size: 30px"
        ></i>
        <!-- <span class="paper-tabal">{{ labal.subLabal }}</span> -->
        <span class="paper-tabal">{{ labal.labal }}</span>
        <span class="paper-text"> > 自留地 </span>
        <span>
          <el-button
            type="text"
            class="set-password-btn"
            icon="el-icon-lock"
            v-if="6 == $route.query.parentId"
            @click="handleSetOrUpdatePassword"
          >
          </el-button>
        </span>
        <common-button
          style="float: right"
          size="default"
          type="cancel"
          image
          @click="handleCancelClick()"
          >返回</common-button
        >
      </div>
    </div>
    <div class="container-body">
      <div class="form-heard">
        <el-form label-width="70px" style="margin-bottom: 5px">
          <div class="body-main-fastener">
            <button
              type="button"
              style="float: left;background-color: #34c5e7 ;font-size: 15px;"
              class="body-main-button icon-icon_wenjianjia iconfont "
              @click="addFile"
            >
              &nbsp;&nbsp;新建文件夹
            </button>
            <button
              type="button"
              class="body-main-button-down icon-shangchuandaochu iconfont "
              @click="importFile"
            >
              上传
            </button>
            <button
              type="button"
              class=" body-main-button-down icon-xiazai iconfont "
              @click="download"
            >
              下载
            </button>
            <button
              type="button"
              class="body-main-button-down icon-changyonggoupiaorenshanchu iconfont "
              @click="deleteClick"
            >
              删除
            </button>
            <div
              class="pending-items-search"
              style="text-align: left;margin-right: 20px"
            >
              <el-form @submit.native.prevent>
                <input
                  v-model="searchForm.keyword"
                  @change="() => (searchQuery.keyword = searchForm.keyword)"
                  placeholder="请输入你要搜索的文件关键词"
                  @keyup.enter="handleSearchClick"
                />
                <i
                  class="iconfont icon-sousuo"
                  @click="handleSearchClick"
                  style="cursor: pointer"
                >
                </i>
              </el-form>
            </div>
          </div>
        </el-form>
      </div>

      <div class="form-body" style="height:calc(100vh - 252px)">
        <div
          style="border-top: 1px solid #e4e7ed;padding:10px 0px;border-bottom: 1px solid #e4e7ed; font-weight: 400;"
        >
          <span
            v-if="isBackBtn"
            class="el-icon-back"
            @click="handleArrowClick"
            style="cursor: pointer"
          ></span>
          <span v-else class="el-icon-back" style="color: #a4b8cc"></span>
          <span
            class="el-icon-refresh-right"
            @click="handleRefreshClick"
            style="cursor: pointer"
          ></span>
          <!-- <span class="to-folder" @click="handleToClick">{{ crumbName }}</span>
          <span
            v-for="(item, index) in crumbNameArr"
            :key="item.id"
            class="to-folder"
            @click="handleToClick(item, index)"
            >{{ item.folderName + "\xa0>\xa0" }}</span
          >
        </div> -->
          <span class="to-folder" @click="handleToClick">
            {{ labal.labal + "\xa0>\xa0" }}</span
          >
          <span
            v-for="(item, index) in crumbNameArr"
            :key="item.id"
            class="to-folder"
            @click="handleToClick(item, index)"
            >{{ item.folderName + "\xa0>\xa0" }}</span
          >
        </div>

        <div v-if="data.list && data.list.length != 0">
          <span
            class="photo-item-panel"
            v-for="(item, index) in data.list"
            :key="item.id"
          >
            <div
              class="photo-item-outside"
              v-if="item.isFolder == '1'"
              @dblclick="viewFolderDetail(item)"
            >
              <div class="photo-item-up">
                <div
                  @mouseenter="changeActive($event, index)"
                  @mouseleave="removeActive($event)"
                >
                  <div
                    class="photo-item-img-outside"
                    :title="item.folderName"
                    :class="{ visited: isvisited == index }"
                    @click="chooseCilck(item, index)"
                  >
                    <div class="photo-item-i">
                      <i
                        class=" iconfont icon-wenjianjia "
                        style="font-size: 100px;color: #FFD15C;"
                      ></i>
                    </div>
                    <div class="photo-item-text">
                      <span>{{ item.folderName }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="photo-item-outside"
              v-else
              @dblclick="preViewAttachment(item, index)"
            >
              <div class="photo-item-up">
                <div
                  @mouseenter="changeActive($event, index)"
                  @mouseleave="removeActive($event)"
                >
                  <div
                    class="photo-item-img-outside"
                    :title="item.attachmentOriginalName"
                    :class="{ visited: isvisited == index }"
                    @click="chooseCilck(item, index)"
                  >
                    <i
                      :class="item | fileIcon(this_)"
                      :style="item | fileColor(this_)"
                      style="font-size: 100px"
                    ></i>
                    <div class="photo-item-text">
                      {{ item.attachmentOriginalName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </span>
        </div>

        <div class="empty-data" v-else>
          <img src="static/images/empty_data.png" />
          <span>暂无数据</span>
        </div>
      </div>
    </div>

    <!-- 图片显示 -->
    <div class="demo-image__preview">
      <el-image ref="previewImg" :preview-src-list="attachment.attachmentsLink">
      </el-image>
    </div>

    <animation
      :loadingDataVisible="
        !attachmentUploadState || !formInfoSaveState || data.isLoading
      "
      :loadingText="loadingText"
    ></animation>

    <!-- 附件上传弹窗 -->
    <el-dialog
      style="text-align: center;"
      title="请导入数据"
      :visible.sync="uploadDialog.isShow"
      @close="closeUploadDialog"
    >
      <div class="dialog-body" style="max-height: 300px; overflow-y: scroll">
        <el-upload
          class="upload-demo"
          drag
          action
          multiple
          :file-list="fileListName"
          :accept="attaFileSuf"
          :http-request="attachmentUpload"
          :on-remove="handleRemove"
          :before-upload="handleBeforeUpload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或<em style="color:#5ed5d9;">点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            仅支持xls/xlsx/ppt/pptx/doc/docx/txt/pdf/jpg/jpeg/png/gif文件
          </div>
        </el-upload>
      </div>
      <el-button
        style="margin-top: 20px"
        type="primary"
        size="small"
        @click="saveUploadData"
      >
        保存数据
      </el-button>
    </el-dialog>
    <!-- 新建文件夹弹窗 -->
    <el-dialog
      width="400px"
      title="文件夹名称"
      :visible="createFolderDilog.isShow"
      @close="closeCreateFolderDialog"
    >
      <el-form @submit.native.prevent>
        <el-input
          v-model="createFolderDilog.folderName"
          placeholder="请输入文件夹名称"
          style="width: 280px"
          @keyup.enter="saveFolderClick"
        ></el-input>
        <el-button
          type="primary"
          size="big"
          @click="saveFolderClick"
          style="background-color: #34c5e7;width: 70px"
          >确定</el-button
        >
      </el-form>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="您的保险箱未授权访问"
      :visible.sync="authDialog.visible"
      class="auth-visit-wrapper"
      width="min(500px, 50%)"
      @close="handleCloseDialog"
    >
      <div>
        <el-form @submit.native.prevent>
          <el-form-item label="保险箱密码：">
            <el-input
              v-model="authDialog.password"
              placeholder="请输入保险箱密码"
              type="password"
              @keydown.native.enter="handleAuthVisit"
              width="min(500px, 50%)"
            >
            </el-input>
          </el-form-item>
          <div class="forget-password-btn">
            <el-button type="text" @click="handleForgetPassword"
              >忘记密码？</el-button
            >
          </div>

          <el-button
            style="margin: 0 auto"
            type="primary"
            @click="handleAuthVisit"
            >确定</el-button
          >
        </el-form>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="authDialog.showOldPwd ? '修改保险箱密码' : '设置保险箱密码'"
      :visible.sync="authDialog.setOrUpdatePasswordVisible"
      class="auth-visit-wrapper"
      @close="handleCloseDialog"
    >
      <div>
        <el-form
          @submit.native.prevent
          :model="authDialog"
          :rules="authDialogRule"
          ref="authDialogForm"
        >
          <el-form-item label="旧密码" v-if="authDialog.showOldPwd">
            <el-input
              size="small"
              type="password"
              v-model="authDialog.oldPassword"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input
              size="small"
              type="password"
              v-model="authDialog.newPassword"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input
              size="small"
              type="password"
              v-model="authDialog.confirmPassword"
            ></el-input>
          </el-form-item>
          <div class="forget-password-btn">
            <el-button type="text" @click="handleForgetPassword"
              >忘记密码？</el-button
            >
          </div>
          <el-button
            style="margin: 0 auto"
            type="primary"
            @click="submitSetOrUpdatePassword"
            >确定</el-button
          >
        </el-form>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="authDialog.forgetPasswordVisible"
      @close="handleCloseDialog"
      title="忘记密码"
      class="auth-visit-wrapper"
      :close-on-click-modal="false"
    >
      <el-form
        @submit.native.prevent
        :model="authDialog"
        :rules="authDialogRule"
        ref="authDialogResetPwdForm"
      >
        <el-form-item label="短信验证码" prop="smsCode">
          <div class="sms-code-input">
            <el-input v-model="authDialog.smsCode" style="flex: 1"></el-input>
            <el-button
              size="small"
              style="width: 100px"
              @click="handleGianSmsCode"
              >{{
                authDialog.timeStart
                  ? `重新获取(${authDialog.timeCount})`
                  : "获取验证码"
              }}</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            size="small"
            type="password"
            v-model="authDialog.newPassword"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            size="small"
            type="password"
            v-model="authDialog.confirmPassword"
          ></el-input>
        </el-form-item>
        <el-button
          style="margin: 0 auto"
          type="primary"
          @click="submitResetPassword"
          >确定</el-button
        >
      </el-form>
    </el-dialog>
    <!-- 附件预览弹窗 -->
    <dialog-preview
      :preViewObj="preViewObj"
      :showPreview="showPreview"
      @handleClosePreview="showPreview = false"
    />
  </div>
</template>

<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import { Message } from "element-ui";
import {
  ATTA_FILE_SHOW_TYPE,
  ATTA_UPLOAD_CASE_SHARE_TYPE_STR,
  ATTA_FILE_DOWN_TYPE,
  ATTA_UPLOAD_COMPONENT_TYPE_STR,
  SINGLE_ATTACHMENT_MAX_SIZE
} from "@/constants/constants";
import animation from "@/components/loading/animation";

export default {
  name: "PaperList",
  components: { animation },
  data() {
    return {
      this_: this, //保存this以便filters中使用
      authDialogRule: {
        smsCode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" }
        ],
        newPassword: [{ validator: this.validatePass, trigger: "blur" }],
        confirmPassword: [{ validator: this.validatePass2, trigger: "blur" }]
      },

      authDialog: {
        //授权访问页面是否显示
        visible: false,
        password: null,
        //修改或者设置密码的弹窗
        setOrUpdatePasswordVisible: false,
        showOldPwd: false,
        oldPassword: null,
        newPassword: null,
        confirmPassword: null,
        //忘记密码的弹窗
        forgetPasswordVisible: false,
        timeCount: 60,
        //记次开始
        timeStart: false,
        timeInterval: null,
        //输入的验证码
        smsCode: null
      },

      searchFlag: null,
      showPreview: false,
      isBackBtn: false,
      //true是结束,false是正在处理
      attachmentUploadState: true,
      //true是结束,false是正在处理
      formInfoSaveState: true,
      loadingText: null,
      zldAttParentId: null, //附件父节点id
      isvisited: -1, //当前选中的index
      parentZldAtta: null, //父节点的文件
      searchParentId: null, //查询的父节点id
      crumbNameArr: [], //面包屑名称
      chooseItem: [], //当前选中的文件
      allAttaList: [], //所有数据
      fileListName: [], //附件名数组
      fileList: [], //附件显示的列表
      preViewObj: {},
      labal: {
        labal: "",
        subLabal: "",
        labalIcon: ""
      },
      data: {
        list: [],
        isLoading: false,
        pageNum: 1,
        pageSize: 9,
        total: 9,
        currentPage: 1,
        userId: ""
      },
      //准备的颜色的数组
      attachmentColors: {
        ppt: "#fd585e",
        pptx: "#fd585e",
        doc: "#2a83eb",
        docx: "#2a83eb",
        xls: "#16b881",
        xlsx: "#16b881",
        pdf: "#ff734c",
        jpg: "#36d2ad",
        jpeg: "#36d2ad",
        png: "#36d2ad",
        gif: "#36d2ad",
        txt: "#a4b8cc"
      },
      fileIconType: {
        ppt: "icon-file-ppt-fill",
        pptx: "icon-file-ppt-fill",
        xls: "icon-file-excel-fill",
        xlsx: "icon-file-excel-fill",
        doc: "icon-file-word-fill",
        docx: "icon-file-word-fill",
        pdf: "icon-file-pdf-fill",
        jpg: "icon-JPG1",
        jpeg: "icon-JPG1",
        png: "icon-JPG1",
        gif: "icon-JPG1",
        txt: "icon-txt1"
      },
      form: {
        zldMenuId: "",
        parentId: null
        // createTm: [this.moment().format("yyyy-MM-DD HH:mm:ss")] //报错了。。。。。。使用前注意报错问题
      },
      dialog: {
        isShow: false,
        caseId: null,
        editFlag: "view"
      },
      uploadDialog: {
        isShow: false
      },
      createFolderDilog: {
        isShow: false,
        folderName: ""
      },
      attachment: {
        attachmentsLink: [],
        //图片的类型后缀
        imagesType: ["jpg", "jpeg", "png", "gif"]
      },
      searchForm: {
        keyword: "" //搜索框绑定的关键字
      },
      searchQuery: {
        keyword: "" //请求传到后端的关键字
      },
      //附件的允许上传的类型
      acceptAttachmentType: ATTA_UPLOAD_CASE_SHARE_TYPE_STR,
      //单个附件的最大的大小
      singleAttachmentSize: SINGLE_ATTACHMENT_MAX_SIZE,
      attaFileSuf: ATTA_UPLOAD_COMPONENT_TYPE_STR,
      acceptAttachmentShowType: ATTA_FILE_SHOW_TYPE,
      acceptAttachmentDownType: ATTA_FILE_DOWN_TYPE
    };
  },
  created() {
    this.getQuery();
  },

  beforeDestroy() {
    //销毁前销毁定时器
    clearInterval(this.authDialog.timeInterval);
  },

  filters: {
    //取截单元,单位
    fileSizeUnit: arg => {
      if (parseFloat(arg) / (1024 * 1024) > 1) {
        return (parseFloat(arg) / (1024 * 1024)).toFixed(2) + "M";
      } else if (parseFloat(arg) / 1024 > 1) {
        return (parseFloat(arg) / 1024).toFixed(2) + "K";
      } else {
        return arg + "B";
      }
    },

    //设置图标的颜色
    fileColor: function(arg, this_) {
      let type = arg.attachmentOriginalName.substring(
        arg.attachmentOriginalName.lastIndexOf(".") + 1
      );
      return "color:" + this_.attachmentColors[type];
    },

    //设置类图标
    fileIcon: function(arg, this_) {
      let type = arg.attachmentOriginalName.substring(
        arg.attachmentOriginalName.lastIndexOf(".") + 1
      );
      return this_.fileIconType[type] + " iconfont";
    }
  },
  watch: {
    $route(to, from) {
      //监听URL地址栏参数变化
      this.query = this.$route.query;
      this.form.zldMenuId = this.query.zldMenuId;
      this.form.parentId = this.query.parentId;
      this.isLoading = true;
    }
  },
  mounted() {
    this.queryData();
    this.getLabal();
  },
  methods: {
    async submitResetPassword() {
      let _this = this;

      let validFlag = false;

      await this.$refs.authDialogResetPwdForm.validate(valid => {
        validFlag = valid;
      });

      if (!validFlag) {
        return;
      }
      _this.data.isLoading = true;
      http
        .post(window.config.api.baseUrl + "/eims-api/zld/Menu/resetPwd", {
          token: cookie.getCookie("token"),
          data: {
            smsCode: _this.authDialog.smsCode,
            smsKey: localStorage.getItem("smsKey"),
            menuId: _this.form.zldMenuId,
            pwd: _this.authDialog.newPassword
          }
        })
        .then(rep => {
          if (rep.data.code === "00000") {
            Message.success("密码重置成功！");
            _this.authDialog.forgetPasswordVisible = false;
            localStorage.removeItem("smsKey");
          }
        })
        .finally(() => {
          _this.data.isLoading = false;
        });
    },

    //获取短信验证码
    handleGianSmsCode() {
      let _this = this;
      //短信验证码正在发送过程中，1分钟之内不允许重复发送
      if (_this.authDialog.timeStart) {
        return;
      }
      _this.data.isLoading = true;
      http
        .post(window.config.api.baseUrl + "/eims-api/zld/Menu/gainSms", {
          token: cookie.getCookie("token"),
          data: {}
        })
        .then(rep => {
          if (rep.data.code === "00000") {
            _this.authDialog.timeStart = true;
            //计时器，1秒执行一次
            _this.authDialog.timeInterval = setInterval(() => {
              _this.authDialog.timeCount--;
              if (_this.authDialog.timeCount <= 0) {
                _this.authDialog.timeStart = false;
                //重置成60
                _this.authDialog.timeCount = _this.$options.data().authDialog.timeCount;
                //清楚计时器
                clearInterval(_this.authDialog.timeInterval);
                //清空计数器对象
                _this.authDialog.timeInterval = null;
              }
            }, 1000);
            //保存短信验证码的key
            localStorage.setItem("smsKey", rep.data.data.smsKey);
          }
        })
        .finally(() => {
          _this.data.isLoading = false;
        });
    },

    //恢复表单的数据
    handleCloseDialog() {
      this.authDialog = this.$options.data().authDialog;
    },

    validatePass(rule, value, callback) {
      // var regex = new RegExp(
      //   "(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{10,20}"
      // );
      if (!value) {
        return callback(new Error("密码不能为空"));
      } else if (value.length < 6 || value.length > 20) {
        return callback(new Error("密码长度为6～20位"));
      } /*else if (!regex.test(value)) {
        return callback(new Error("密码必需包含数字、大小写字母和字符"));
      } */ else {
        if (this.authDialog.confirmPassword !== "") {
          if (this.$refs.authDialogForm) {
            this.$refs.authDialogForm.validateField("confirmPassword");
          } else if (this.$refs.authDialogResetPwdForm) {
            this.$refs.authDialogResetPwdForm.validateField("confirmPassword");
          }
        }
        callback();
      }
    },

    validatePass2(rule, value, callback) {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.authDialog.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    },

    /**
     * 点击忘记密码
     */
    handleForgetPassword() {
      this.authDialog = this.$options.data().authDialog;
      this.$nextTick(() => {
        this.authDialog.forgetPasswordVisible = true;
      });
    },

    /**
     * 更新密码
     */
    async submitSetOrUpdatePassword() {
      let _this = this;

      let validFlag = false;

      await this.$refs.authDialogForm.validate(valid => {
        validFlag = valid;
      });

      if (!validFlag) {
        return;
      }

      //修改密码
      if (this.authDialog.showOldPwd) {
        _this.data.isLoading = true;
        http
          .post(window.config.api.baseUrl + "/eims-api/zld/Menu/updatePwd", {
            token: cookie.getCookie("token"),
            data: {
              menuId: _this.form.zldMenuId,
              oldPwd: _this.authDialog.oldPassword,
              newPwd: _this.authDialog.newPassword
            }
          })
          .then(rep => {
            if (rep.data.code === "00000") {
              Message.success("密码修改成功！");
              _this.authDialog.setOrUpdatePasswordVisible = false;
              _this.authDialog.oldPassword = null;
              _this.authDialog.newPassword = null;
              _this.authDialog.confirmPassword = null;
            }
          })
          .finally(() => {
            _this.data.isLoading = false;
          });

        //设置密码
      } else {
        _this.data.isLoading = true;
        http
          .post(window.config.api.baseUrl + "/eims-api/zld/Menu/setPwd", {
            token: cookie.getCookie("token"),
            data: {
              menuId: _this.form.zldMenuId,
              newPwd: _this.authDialog.newPassword
            }
          })
          .then(rep => {
            if (rep.data.code === "00000") {
              Message.success("密码设置成功！");
              _this.authDialog.setOrUpdatePasswordVisible = false;
              _this.authDialog.oldPassword = null;
              _this.authDialog.newPassword = null;
              _this.authDialog.confirmPassword = null;
            }
          })
          .finally(() => {
            _this.data.isLoading = false;
          });
      }
    },

    /**
     * 设置或者更新一个密码
     */
    handleSetOrUpdatePassword() {
      let _this = this;
      //先查询是否存在旧密码
      this.data.isLoading = true;
      http
        .post(window.config.api.baseUrl + "/eims-api/zld/Menu/existPwd", {
          token: cookie.getCookie("token"),
          data: {
            menuId: _this.form.zldMenuId
          }
        })
        .then(rep => {
          if (rep.data.code === "00000") {
            _this.authDialog.showOldPwd = rep.data.data.existPwd;
            _this.authDialog.setOrUpdatePasswordVisible = true;
          }
        })
        .finally(() => {
          this.data.isLoading = false;
        });
    },

    //授权访问
    handleAuthVisit() {
      let _this = this;
      http
        .post(window.config.api.baseUrl + "/eims-api/zld/Menu/authVisit", {
          token: cookie.getCookie("token"),
          data: {
            pwd: _this.authDialog.password,
            menuId: _this.form.zldMenuId
          }
        })
        .then(rep => {
          if (rep.data.code === "00000") {
            cookie.setCookie("zldAuthKey", rep.data.data.authKey);
            _this.queryData();
            _this.authDialog.visible = false;
          }
        })
        .finally(() => {
          //清空密码
          _this.authDialog.password = null;
        });
    },

    //回退按钮
    handleArrowClick() {
      if (this.parentZldAtta && this.parentZldAtta.id) {
        if (this.parentZldAtta.parentId) {
          this.isBackBtn = true;
        } else {
          this.isBackBtn = false;
        }
        this.zldAttParentId = this.parentZldAtta.parentId;
        this.crumbNameArr.splice(-1);
      } else {
        this.isBackBtn = false;
        // this.crumbNameArr = [
        //   {
        //     id: this.labal.subLabal,
        //     folderName: this.labal.subLabal
        //   }
        // ];
        this.searchQuery.keyword = "";
      }
      this.queryData();
    },

    //刷新按钮
    handleRefreshClick() {
      this.queryData();
    },
    //跳转
    handleToClick(item, index) {
      this.crumbNameArr.splice(index + 1);
      this.zldAttParentId = item.id;
      this.queryData();
    },

    //鼠标移动到文件，背景色改变
    changeActive(e, index) {
      e.currentTarget.className = "photo-item-img-outside-active";
    },

    //鼠标移走，无背景色
    removeActive(e) {
      e.currentTarget.className = "";
    },

    //点击选中文件，背景色加深
    chooseCilck(item, index) {
      debugger;
      this.isvisited = index;
      this.chooseItem = item;
    },

    getLabal() {
      this.data.isLoading = true;
      http
        .post(window.config.api.baseUrl + "/eims-api/zld/Menu/subtitle", {
          token: cookie.getCookie("token"),
          data: {
            zldMenuId: this.form.zldMenuId
          }
        })
        .then(response => {
          let data = response.data;
          if (data.code == "00000") {
            if (data.data) {
              this.labal.labal = data.data.labal.name;
              this.labal.subLabal = data.data.subLabal.name;
              this.labal.labalIcon = data.data.labal.icon;
              // this.crumbNameArr.push({
              //   id: data.data.subLabal.name,
              //   folderName: data.data.subLabal.name
              // });
            }
          }
        })
        .finally(() => {
          this.data.isLoading = false;
        });
    },

    //抓取页面的parentId
    getQuery() {
      this.query = this.$route.query;
      this.form.zldMenuId = this.query.zldMenuId;
      this.form.parentId = this.query.parentId;
      this.isLoading = true;
    },
    //分页
    handlePageChange(val) {
      this.data.pageNum = val;
      this.queryData();
    },

    queryData() {
      let _this = this;
      this.data.isLoading = true;
      if (this.searchFlag == 1) {
        if (_this.searchQuery.keyword) {
          this.crumbNameArr = [
            // {
            //   id: this.labal.subLabal,
            //   folderName: this.labal.subLabal
            // },
            {
              id: "搜索结果",
              folderName: "“" + this.searchQuery.keyword + "”的搜索结果"
            }
          ];
        } else {
          this.crumbNameArr = [
            // {
            //   id: this.labal.subLabal,
            //   folderName: this.labal.subLabal
            // }
          ]; //搜索框搜索后，删除搜索框内容，面包屑显示情况
          this.form.zldMenuId = this.$route.query.zldMenuId;
          this.zldAttParentId = null;
        }
      }
      if (this.searchQuery.keyword) {
        this.isBackBtn = true;
      }
      http
        .post(window.config.api.baseUrl + "/eims-api/zld/atta/list", {
          token: cookie.getCookie("token"),
          data: {
            // pageNum: _this.data.pageNum,
            // pageSize: _this.data.pageSize,
            keyword: _this.searchQuery.keyword,
            zldMenuId: _this.form.zldMenuId,
            zldAttParentId: this.zldAttParentId
              ? Number(this.zldAttParentId)
              : null,
            authKey: cookie.getCookie("zldAuthKey")
          }
        })
        .then(function(response) {
          if (response.data.code === "00000") {
            let data = response.data.data;
            _this.data.list = data.list;
            //获取该list的父亲
            _this.parentZldAtta = data.parentZldAtta;
            if (_this.searchFlag === 1) {
              _this.parentZldAtta = null;
              _this.zldAttParentId = null;
            }
            _this.allAttaList = data.allAttaList;
            _this.data.userId = data.userId;
          }

          //菜单需要授权访问
          if (response.data.code === "10045") {
            _this.authDialog.visible = true;
          }
        })
        .finally(() => {
          _this.data.isLoading = false;
          this.isvisited = -1;
          this.chooseItem = [];
        });
    },

    addFile() {
      this.createFolderDilog.isShow = true;
    },

    importFile() {
      this.uploadDialog.isShow = true;
    },

    download() {
      if (this.chooseItem.length != 0) {
        if (this.chooseItem.isFolder != "1") {
          this.handleDown(this.chooseItem);
        } else {
          Message.warning("文件夹无法下载！");
        }
      } else {
        Message.warning("请选择需要下载的文件");
      }
    },

    deleteClick() {
      let ids = [];
      if (this.chooseItem.length != 0 && this.chooseItem.id != null) {
        ids.push(this.chooseItem.id);
        if (
          this.chooseItem.zldAttaChidren &&
          this.chooseItem.zldAttaChidren.length != 0
        ) {
          ids = this.collectIds(this.chooseItem.zldAttaChidren, ids);
        }
        this.deleteFunction(ids);
      } else {
        Message.warning("请选择需要删除的文件");
      }
    },

    collectIds(attaChidren, ids) {
      if (attaChidren.length != 0) {
        attaChidren.forEach(arr => {
          if (arr.id != null) {
            ids.push(arr.id);
            if (arr.zldAttaChidren && arr.zldAttaChidren.length != 0) {
              ids = this.collectIds(arr.zldAttaChidren, ids);
            }
          }
        });
        return ids;
      } else {
        return ids;
      }
    },

    deleteFunction(ids) {
      let _this = this;
      this.$confirm("确实将该文件删除？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        http
          .post(window.config.api.baseUrl + "/eims-api/zld/atta/delete", {
            token: cookie.getCookie("token"),
            data: {
              ids: ids,
              zldMenuId: _this.form.zldMenuId,
              authKey: cookie.getCookie("zldAuthKey")
            }
          })
          .then(response => {
            if ((response.data.code = "00000")) {
              Message.success("删除成功！");
              this.queryData();
            }
          })
          .finally(() => {
            this.data.isLoading = false;
          });
      });
    },

    handleSearchClick() {
      this.searchQuery.keyword = this.searchForm.keyword;
      this.searchFlag = 1;
      this.queryData();
      this.searchFlag = null;
    },

    handleCancelClick() {
      this.$router.go(-1);
    },

    //点击文件夹
    viewFolderDetail(item) {
      if (this.searchQuery.keyword) {
        //获取父节点的文件名
        // this.crumbNameArr = [
        //   {
        //     id: this.labal.subLabal,
        //     folderName: this.labal.subLabal
        //   }
        // ];
        let parentFolderName = [];
        if (item.parentId) {
          this.allAttaList.forEach(arr => {
            if (item.parentId == arr.id) {
              parentFolderName.unshift(item);
              if (arr.parentId) {
                parentFolderName.unshift(arr);
                this.getParentFolderName(arr.parentId, parentFolderName);
              }
            }
          });
        } else {
          parentFolderName.push(item);
        }
        this.crumbNameArr = this.crumbNameArr.concat(parentFolderName);
        this.searchQuery.keyword = "";
      } else {
        this.crumbNameArr.push(item);
      }
      this.isBackBtn = true;
      this.zldAttParentId = item.id;
      this.queryData();
    },

    //递归获取父节点的文件名
    getParentFolderName(parentId, parentFolderName) {
      this.allAttaList.forEach(arr => {
        if (parentId == arr.id) {
          parentFolderName.unshift(arr);
          if (arr.parentId) {
            parentFolderName = this.getParentFolderName(
              arr.parentId,
              parentFolderName
            );
          } else {
            return parentFolderName;
          }
        }
      });
      return parentFolderName;
    },

    handleBeforeUpload(file) {
      let testMsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (!this.attaFileSuf.includes(testMsg)) {
        this.$message({
          message: "上传附件类型不合法！",
          type: "warning",
          showClose: true
        });
        return false;
      } else {
        return true;
      }
    },

    handleRemove(file, fileList) {
      this.fileListName = fileList;
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].file.uid == file.uid) {
          this.fileList.splice(i, 1);
        }
      }
    },

    attachmentUpload(file, fileList) {
      //由于组件可能存在问题 ,直接共用一个list会出现选择文件之后文件列表不显示文件名的情况
      //所以需要定义两个,一个用于显示文件名,一个用于接受文件
      // this.fileListName = [];
      // this.fileList = [];
      let fileInfo = {
        name: file.file.name,
        uid: file.file.uid
      };
      this.fileList.push(file);
      this.fileListName.push(fileInfo);
    },

    closeUploadDialog() {
      this.fileListName = [];
      this.fileList = [];
      this.uploadDialog.isShow = false;
    },

    closeCreateFolderDialog() {
      this.createFolderDilog.isShow = false;
      this.createFolderDilog.folderName = "";
    },

    //保存数据
    saveUploadData() {
      if (this.fileList.length == 0) {
        Message.warning("请选择需要上传的附件！");
        return false;
      }
      Message.info("数据导入可能需要几分钟,请耐心等待");
      let that = this;
      // 使用form表单的数据格式
      const paramsData = new FormData();
      // 将上传文件数组依次添加到参数paramsData中
      this.fileList.forEach((it, index) => {
        paramsData.append(`file`, it.file);
      });
      if (this.fileList.length === 0) {
        paramsData.append(`file`, null);
      }
      let jsonData = {
        token: cookie.getCookie("token"),
        data: {
          attachment: this.fileListName,
          zldData: {
            zldMenuId: this.form.zldMenuId,
            parentId: this.zldAttParentId ? Number(this.zldAttParentId) : null
          },
          authKey: cookie.getCookie("zldAuthKey")
        }
      };
      console.log("jsonData", jsonData);
      //将表单数据添加到参数paramsData中,需要将参数转化成Blob后端才能识别到文件
      paramsData.append(
        "data",
        new Blob([JSON.stringify(jsonData)], { type: "application/json" })
      );
      // 表单数据和文件一起上传,调用后端接口
      this.attachmentUploadState = false;
      http
        .post(
          window.config.api.baseUrl + "/eims-api/zld/atta/saveFile",
          paramsData
        )
        .then(response => {
          if (response.data.code === "00000") {
            Message.success("保存成功!");
            this.queryData();
            this.fileListName = [];
            this.fileList = [];
            this.uploadDialog.isShow = false;
          }

          //菜单需要授权访问
          if (response.data.code === "10045") {
            this.authDialog.visible = true;
          }
        })
        .finally(() => {
          this.attachmentUploadState = true;
        });
    },
    //保存文件夹
    saveFolderClick() {
      if (!this.createFolderDilog.folderName) {
        Message.warning("文件夹名字不能为空！");
        return false;
      } else if (this.createFolderDilog.folderName.length > 60) {
        Message.warning("文件夹名字长度须在60个字符之内！");
        return false;
      }

      let flag = false;
      this.data.list.forEach(arr => {
        if (arr.folderName == this.createFolderDilog.folderName) {
          flag = true;
          return false;
        }
      });
      if (flag) {
        Message.warning("已有该文件夹！");
        return false;
      }
      this.attachmentUploadState = false;
      http
        .post(window.config.api.baseUrl + "/eims-api/zld/atta/saveFolder", {
          token: cookie.getCookie("token"),
          data: {
            zldMenuId: this.form.zldMenuId,
            folderName: this.createFolderDilog.folderName,
            parentId: this.zldAttParentId ? Number(this.zldAttParentId) : null,
            authKey: cookie.getCookie("zldAuthKey")
          }
        })
        .then(response => {
          if (response.data.code === "00000") {
            Message.success("保存成功!");
            this.queryData();
            this.createFolderDilog.isShow = false;
          }

          //菜单需要授权访问
          if (response.data.code === "10045") {
            this.authDialog.visible = true;
          }
        })
        .finally(() => {
          this.attachmentUploadState = true;
        });
    },

    //点击查看按钮
    preViewAttachment(item) {
      this.preViewObj = item;
      if (item.localUrl) {
        this.preViewObj.url = item.localUrl;
      } else {
        this.preViewObj.url =
          window.config.api.baseUrl +
          "/eims-api/attachment/findFile?token=" +
          cookie.getCookie("token") +
          "&code=" +
          item.code;
      }
      this.showPreview = true;
    },

    //准备需要查看的附件的链接,然后显示或者下载附件
    handleView(item) {
      let fileType = item.attachmentOriginalName.substring(
        item.attachmentOriginalName.lastIndexOf(".") + 1
      );
      const elink = document.createElement("a");
      http
        .get(
          window.config.api.baseUrl +
            "/eims-api/attachment/findFile?token=" +
            cookie.getCookie("token") +
            "&code=" +
            item.code,
          { responseType: "blob" }
        )
        .then(response => {
          if (response) {
            let attaFileDownTypeElement = this.acceptAttachmentDownType[
              fileType
            ];
            elink.download = item.attachmentOriginalName.substring(
              0,
              item.attachmentOriginalName.lastIndexOf(".")
            );
            elink.style.display = "none";
            elink.target = "_blank";
            elink.href = URL.createObjectURL(
              new Blob([response.data], { type: attaFileDownTypeElement })
            );
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    //准备需要查看的附件的链接,然后显示或者下载附件
    handleDown(item) {
      if (item.file) {
        let fileType = item.file.name.substring(
          item.file.name.lastIndexOf(".") + 1
        );
        let attaFileTypeElement = this.acceptAttachmentShowType[fileType];
        const elink = document.createElement("a");
        if (!attaFileTypeElement) {
          elink.download = item.file.name;
        }
        elink.style.display = "none";
        elink.target = "_blank";
        // elink.href = URL.createObjectURL(new Blob([item.file.raw],{type:attaFileTypeElement}));
        elink.href = URL.createObjectURL(item.file);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      } else {
        let fileType = item.attachmentOriginalName.substring(
          item.attachmentOriginalName.lastIndexOf(".") + 1
        );
        let attaFileTypeElement = this.acceptAttachmentShowType[fileType];
        const elink = document.createElement("a");
        http
          .get(
            window.config.api.baseUrl +
              "/eims-api/attachment/findFile?token=" +
              cookie.getCookie("token") +
              "&code=" +
              item.code,
            { responseType: "blob" }
          )
          .then(response => {
            if (response) {
              let attaFileDownTypeElement = this.acceptAttachmentDownType[
                fileType
              ];
              elink.download = item.attachmentOriginalName.substring(
                0,
                item.attachmentOriginalName.lastIndexOf(".")
              );
              elink.style.display = "none";
              elink.target = "_blank";
              elink.href = URL.createObjectURL(
                new Blob([response.data], { type: attaFileDownTypeElement })
              );
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href);
              document.body.removeChild(elink);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },

    //设置图标的颜色
    fileColor: function(arg, this_) {
      let type = arg.attachmentOriginalName.substring(
        arg.attachmentOriginalName.lastIndexOf(".") + 1
      );
      return "color:" + this_.attachmentColors[type];
    },

    //设置类图标
    fileIcon: function(arg, this_) {
      let type = arg.attachmentOriginalName.substring(
        arg.attachmentOriginalName.lastIndexOf(".") + 1
      );
      return this_.fileIconType[type] + " iconfont";
    }
  }
};
</script>

<style lang="scss" scoped>
.paper-list {
  margin: 20px;
  background-color: #fff;
  box-shadow: 1px 2px 5px #ccc;
  min-height: calc(100vh - 109px);
  .container-head {
    border-bottom: 1px solid #f5f5f5;
    padding: 10px;
    line-height: 20px;
    overflow: auto;
    .container-head-title {
      display: block;
      vertical-align: middle;
      text-align: left;
      .paper-tabal {
        padding-left: 10px;
        font-family: SourceHanSansSC;
        font-weight: 700;
        font-size: 24px;
        color: rgb(8, 39, 44);
        font-style: normal;
        letter-spacing: 0px;
        line-height: 20px;
        text-decoration: none;
      }
      .paper-text {
        border: none;
        font-family: SourceHanSansSC;
        font-weight: 400;
        font-size: 18px;
        color: rgb(8, 39, 44);
        font-style: normal;
        letter-spacing: 0px;
        line-height: 20px;
        text-decoration: none;
      }
      .set-password-btn:hover {
        background-color: transparent;
      }
    }
  }
  .container-body {
    padding: 10px;
    .form-heard {
      .body-main-button {
        border: none;
        color: rgb(241, 247, 255);
        outline: none;
        border-radius: 3px;
        width: 120px;
        height: 35px;
        text-align: center;
        background-image: url("/static/images/fourbackground.png");
      }
      .body-main-button-down {
        float: left;
        border: 1px solid rgb(132, 198, 252);
        margin-left: 10px;
        background-color: rgb(248, 251, 255);
        color: #34c5e7;
        outline: none;
        border-radius: 3px;
        width: 85px;
        height: 35px;
        text-align: center;
        background-image: url(/static/images/fourbackground.png);
        &:hover {
          background-color: #e9f1f8;
        }
        &:active {
          background-color: #dfecfa;
        }
      }
      .pending-items-search input {
        padding-left: 15px;
        width: 330px;
        margin-left: 10px;
        height: 35px;
        border-style: none;
        border-color: unset;
        border-radius: 15px;
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        background: rgb(238, 244, 251);
        outline-color: #caecf5;
      }
    }
    .form-body {
      overflow: auto;
      .el-icon-back:hover {
        color: #34c5e7;
      }
      .el-icon-back:active {
        color: #34c5e7;
      }
      .el-icon-refresh-right:hover {
        color: #34c5e7;
      }
      .el-icon-refresh-right:active {
        color: #34c5e7;
      }
      .to-folder {
        padding-left: 10px;
        cursor: pointer;
        &:hover {
          color: #34c5e7;
        }
      }
      .photo-item-panel {
        padding: 20px;
      }
      .photo-item-outside {
        width: 120px;
        margin-top: 20px;
        margin-left: 20px;
        border-radius: 8px;
        display: inline-block;
      }
      .photo-item-up {
        text-align: center;
        img {
          width: 180px;
          height: 180px;
          border-radius: 10px;
        }
        .photo-item-img-outside {
          border-radius: 10px;
          .photo-item-text {
            font-size: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1; /* 这里数字可以根据需要自行调整，表示截取到几行 */
            -webkit-box-orient: vertical;
          }
        }
        .visited {
          border-radius: 10px;
          background-color: rgb(215, 243, 251);
        }
        .photo-item-img-outside-active {
          border-radius: 10px;
          background-color: rgb(237, 244, 251);
        }
      }
      .empty-data {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        img {
          width: 25%;
        }
        span {
          font-size: 18px;
          color: #999999;
        }
      }
    }
  }
  /*授权访问弹窗页面样式*/
  .auth-visit-wrapper {
    display: flex;
    align-items: center;
    .forget-password-btn {
      float: right;
      position: relative;
      top: -13px;
    }

    /deep/ .el-form-item__label {
      line-height: 20px;
    }

    .sms-code-input {
      display: flex;
      justify-content: center;
      width: 100%;
    }

    .sms-code-input > * {
      margin: 0 5px;
    }
  }
}
i.icon-file-word-fill {
  color: #008dfa;
  font-size: 40px;
}
i.icon-wenjianjia {
  color: #f09f19;
  font-size: 40px;
}
i.icon-PDF {
  color: #eb5e5e;
  font-size: 40px;
}
i.icon-file-excel-fill {
  color: #00c090;
  font-size: 40px;
}
i.icon-file-ppt-fill {
  color: #ff7082;
  font-size: 40px;
}
i.icon-daochu {
  color: rgb(52, 197, 231);
  font-size: 18px;
}
i.icon-icon_wenjianjia {
  color: rgb(52, 197, 231);
  font-size: 18px;
}
.icon-xiazai:before {
  font-size: 20px;
  margin-right: 8px;
}
.icon-shangchuandaochu:before {
  font-size: 20px;
  margin-right: 8px;
}
.icon-changyonggoupiaorenshanchu:before {
  font-size: 20px;
  margin-right: 8px;
}
.icon-daochu:before {
  font-size: 20px;
  margin-right: 8px;
}
i.icon-sousuo {
  margin-left: -35px;
  color: #34caee;
}

/deep/ .el-image__error {
  display: none;
}
/deep/ .el-table .cell {
  line-height: unset;
}
</style>



// WEBPACK FOOTER //
// src/pages/privateplot/PaperList.vue